"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var findGengo_1 = require("./findGengo");
function atai(date) {
    var seirekiNen = date.getFullYear();
    var tsuki = date.getMonth() + 1;
    var hi = date.getDate();
    var ji = date.getHours();
    var fun = date.getMinutes();
    var byo = date.getSeconds();
    var _a = findGengo_1.default(date), gengoStart = _a.start, gengo = _a.full, tanGengo = _a.short, alphaGengo = _a.alpha;
    var seireki = date.getFullYear();
    var wareki = { gengo: gengo, tanGengo: tanGengo, alphaGengo: alphaGengo, nen: seirekiNen - gengoStart[0] + 1 };
    return { seireki: seireki, wareki: wareki, tsuki: tsuki, hi: hi, ji: ji, fun: fun, byo: byo };
}
exports.default = atai;
